export const eventCommunityStyles = () => ({
	community: {
		border: '1px solid #9B9B9B1A',
		backgroundColor: '#32323280',
		p: '24px 32px',
		borderRadius: '8px',
	},
	communityName: {
		fontFamily: 'General Sans',
		fontSize: '18px',
		fontWeight: 700,
		lineHeight: '24px',
		color: '#FFFFFF',
	},
	communityDescription: {
		fontFamily: 'Hind',
		fontSize: '15px',
		fontWeight: 500,
		lineHeight: '24px',
		color: '#FFFFFF',
	},
	communityAvatarGroup: {
		'& .MuiAvatar-root': {
			border: '1.5px solid #F4F4F4',
			width: '32px',
			height: '32px',
		},
	},
	communityFollowers: {
		fontFamily: 'Hind',
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '22px',
		color: '#FFFFFF',
	},
	link: {
		fontFamily: 'General Sans',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '18px',
		color: '#FFFFFFCC',
		cursor: 'pointer',

		"&:hover": {
			textDecoration: 'underline',
		}
	},
	button: {
		width: 'fit-content',
		height: '48px',
		fontFamily: 'Integral CF',
		fontSize: '12px',
		fontWeight: 500,
		lineHeight: '14px',
		borderRadius: '100px',
		backgroundColor: 'transparent',
		color: '#FFFFFF',
		border: '1px solid #FFFFFF4D',
		p: '16px 22px',
		gap: '10px',

		"& >svg": {
			width: '24px',
			height: '24px',
		},

		'&:hover': {
			backgroundColor: '#FFFFFF',
			color: '#000000',

			'& >svg': {
				color: '#000000',
			},
		},
	},
});
